import FavoriteList from 'components/FavoritePlaces/FavoriteList';
import SideCloseBtn from 'components/SideCloseBtn';
import useBrekpoint from 'hooks/useBrekpoint';
import ChevronDown from 'Icons/ChevronDown';
import { useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import useFavorites from 'store/useFavorites';
import { CloseBtn, Content, Wrapper } from './Favorites.styles';
import { getDistanceWithUnit } from 'utils/helpers';
import { getDistance } from 'geolib';

export default function Favorites() {
  const { activeFilter, favorites, programs } = useFavorites();
  const { isSmallDevice } = useBrekpoint();

  const navigate = useNavigate();
  const adaptedPrograms = Object.keys(programs)?.map((programName) => {
    const program = programs[programName];
    //get distance
    const programWithoutEmptyDays = program.filter(
      (day) => typeof day[0] !== 'string',
    );
    const firstPlaceCoords = {
      latitude: programWithoutEmptyDays[0][0]?.location.coordinates[1],
      longitude: programWithoutEmptyDays[0][0]?.location.coordinates[0],
    };

    const lastPlaceCoords = {
      latitude:
        programWithoutEmptyDays[0].slice(-1)[0]?.location?.coordinates[1],
      longitude:
        programWithoutEmptyDays[programWithoutEmptyDays.length - 1].slice(-1)[0]
          ?.location?.coordinates[0],
    };

    const distance = getDistanceWithUnit(
      getDistance(firstPlaceCoords, lastPlaceCoords) * 1.4,
    );
    //get the regions
    const regions = [];
    program.flat().forEach((place) => {
      const regionSlug =
        typeof place === 'string' ? place : place?.contact?.address?.city;
      if (!regions.includes(regionSlug)) {
        regions.push(regionSlug);
      }
    });

    return {
      type: 'program',
      regions: regions.length,
      days: program.length,
      distance,
      id: programName,
      title: programName,
      image: programs[programName][0][0].media[0].url,
    };
  });

  const getList = () => {
    switch (activeFilter) {
      case 'all':
        return [...favorites, ...adaptedPrograms];
      case 'programs':
        return adaptedPrograms;
      case 'places':
        return favorites;
      default:
        return [...favorites, adaptedPrograms];
    }
  };
  const handleClose = () => {
    pageRef?.current?.classList.add('animate__fadeOutDown');

    setTimeout(() => {
      navigate('/');
    }, 600);
  };
  const pageRef = useRef(null);
  return (
    <Wrapper
      ref={pageRef}
      className={`animate__animated ${
        isSmallDevice ? 'animate__fadeInUp' : 'animate__fadeInLeft'
      } `}
    >
      <SideCloseBtn page={pageRef} />
      <CloseBtn onClick={handleClose}>
        <ChevronDown />
      </CloseBtn>
      <Content>
        <FavoriteList items={getList()} active={activeFilter} />
      </Content>
    </Wrapper>
  );
}
